<div class="pagination-control component">
  <!-- PREV BUTTON -->
  <button
    mat-button
    [disabled]="prevDisabled"
    class="prev-btn"
    (click)="prevClicked($event)"
  >
    @if (prevIconName) {
    <span class="icon">
      <firebird-web-icon [name]="prevIconName" width="7px"></firebird-web-icon>
    </span>
    } @if (prevLabelKey) {
    <span class="label" [translate]="prevLabelKey"></span>
    }
  </button>

  <!-- NEXT BUTTON -->
  <button
    mat-button
    [disabled]="nextDisabled"
    class="next-btn"
    (click)="nextClicked($event)"
  >
    @if (nextLabelKey) {
    <span class="label" [translate]="nextLabelKey"></span>
    } @if (nextIconName) {
    <span class="icon"
      ><firebird-web-icon [name]="nextIconName" width="7px"></firebird-web-icon
    ></span>
    }
  </button>
</div>
